const maxWidth = 1920;

export default {
    maxWidthInt: maxWidth,
    maxWidth: `${maxWidth}px`,
    sitePaddingXMobile: 20,
    sitePaddingXDesktop: 48,
    headerHeight: 58,
    minimizedHeaderHeight: 72,
    headerHeightMobile: 58,
    headerHeightTablet: 58,
    headerHeightDesktop: 58,
    searchInputHeightMobile: 52,
    searchInputHeightTablet: 52,
    topMenuHeight: 56, //element height plus bottom margin
    checkoutHeaderHeight: 48,
    uspHeight: 24,
} as const;
